// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3j1c2","infoBtn":"quickbooks_infoBtn__1DUR9","formBox":"quickbooks_formBox__1xTfR","formFooter":"quickbooks_formFooter__2nqAv"};